export const GET_COURIERS = 'GET_COURIERS'
export const GET_COURIERS_EXITO = 'GET_COURIERS_EXITO'
export const GET_COURIERS_ERRROR = 'GET_COURIERS_ERROR'
